export default [{
  path: '/parcelamento-mei/relp',
  component: {
    name: 'parcelamentoPertMeiBase',
    template: '<router-view />',
    meta: {
      resource: 'parcelamento_relpmei',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'parcelamento_relpmei-view',
    component: () => import('@/app/parcelamentos-mei/parcelamento-relp/ParcelamentoRelpView.vue'),
    meta: {
      tipo: 'relp',
      resource: 'parcelamento_relpmei',
      action: 'read',
      navActiveLink: 'parcelamento_relpmei-view',
      pageTitle: 'Relp',
      breadcrumb: [
        {
          text: 'Parcelamento Relp',
          to: { name: 'parcelamento_relpmei-view' },
          active: true,
        },
      ],
    },
  }],
},
]
